import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import FormInput from "../common/form-controls/input";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { DialogButtonPrimary, UserContainer } from "../user-profile/style";
import { FlexGridItem, HideForRoles } from "../detail/form_utility";
import { accessTypeData } from "src/constants/dropdown";
import FormSelect from "../common/form-controls/select";
import { actionSaveUserAccessRequest, resetAuthenticationStatus } from "../user-profile/actions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Loader } from "../common/loader.component";
import { Toaster } from "../common/toaster.component";
import { closeToaster } from "src/actions/common";
import { CustomButton } from "src/styles/general";
import { SIGN_OUT_PATH } from "src/constants/api";
import { history } from "../../store/config";

export default function AccessRequestComponent(props: any) {
    const dispatch = useDispatch();
    const [email, setEmail] = useState("");
    const [validateSchema, setValidateSchema]: any = useState({});

    const isLoaderVisible = useSelector((state: any) => state.common.isLoaderVisible);

    const toasterMessage = useSelector((state: any) => state.common.toasterMessage);
    const isToasterVisible = useSelector((state: any) => state.common.isToasterVisible);
    const isSuccessMessage = useSelector((state: any) => state.common.isSuccess);

    const isAccessRequestSent = useSelector(
        (state: any) => state.userProfile.isAccessRequestSent
    );

    const methods = useForm({
        resolver: yupResolver(validateSchema),
    });

    const {
        handleSubmit,
        formState: { errors },
        setValue,
        reset
    } = methods;

    useEffect(() => {
        if (props.location && props.location.search) {
            const splitArray = props.location.search.split("=");
            if (splitArray && splitArray.length) {
                setEmail(splitArray[1]);

            }
        }

        setValidateSchema(
            yup.object().shape({
                firstName: yup
                    .string()
                    .trim()
                    .required("Please enter first name"),
                lastName: yup
                    .string()
                    .trim()
                    .required("Please enter last name"),
                userEmail: yup
                    .string()
                    .trim()
                    .required("Please enter email")
                    .email("Please enter valid email"),
                accessFor: yup
                    .string()
                    .trim()
                    .required("Please select access for"),
            })
        );
    }, [])

    useEffect(() => {
        if (email) {
            setValue("userEmail", email || "")
        }
    }, [email])

    useEffect(() => {        
        if (isAccessRequestSent) {
            dispatch(resetAuthenticationStatus());
            history.replace(SIGN_OUT_PATH);
            window.location.reload();
        }
    }, [isAccessRequestSent])

    const onSubmit = (data: any) => {
        let formData: any = {
            email: data.userEmail.trim(),
            firstName: data.firstName,
            lastName: data.lastName,
            accessFor: data.accessFor
        };
        dispatch(actionSaveUserAccessRequest(formData));
        reset();
        if (email) {
            setValue("userEmail", email || "")
        }
    };

    const logout = () => {
        dispatch(resetAuthenticationStatus());
        history.replace(SIGN_OUT_PATH);
        window.location.reload();
    };

    return <>
        {
            <FormProvider {...methods}>
                <Loader visible={isLoaderVisible} />
                <Toaster
                    message={toasterMessage}
                    open={isToasterVisible}
                    close={closeToaster}
                    success={isSuccessMessage}
                />
                <form>
                    <Grid container={true} spacing={2}>
                        <FlexGridItem xs={4} />
                        <FlexGridItem xs={4}>
                            <h3>
                                Please send access request
                            </h3>
                        </FlexGridItem>
                    </Grid>
                    <Grid container={true} spacing={2}>
                        <FlexGridItem xs={4} />
                        <FlexGridItem xs={4}>
                            <FormInput
                                name="firstName"
                                label={"First Name"}
                                required={true}
                                errorobj={errors}
                            />
                        </FlexGridItem>
                    </Grid>
                    <Grid container={true} spacing={2}>
                        <FlexGridItem xs={4} />
                        <FlexGridItem xs={4}>
                            <FormInput
                                name="lastName"
                                label={"Last Name"}
                                required={true}
                                errorobj={errors}
                            />
                        </FlexGridItem>
                    </Grid>

                    <Grid container={true} spacing={2}>
                        <FlexGridItem xs={4} />
                        <FlexGridItem xs={4}>
                            <FormInput
                                name="userEmail"
                                inputProps={{
                                    readonly: true,
                                }}
                                disabled={true}
                                label={"Email"}
                                required={true}
                                errorobj={errors}
                            />
                        </FlexGridItem>
                    </Grid>
                    <Grid container={true} spacing={2}>
                        <FlexGridItem xs={4} />
                        <FlexGridItem xs={4}>
                            <FormSelect
                                label="Access for"
                                name="accessFor"
                                options={accessTypeData}
                                required={true}
                                errorobj={errors}
                            />
                        </FlexGridItem>
                    </Grid>
                    <Grid container spacing={2} className="padding20">
                        <FlexGridItem xs={4} />
                        <FlexGridItem xs={4}>
                            <DialogButtonPrimary
                                variant="contained"
                                color="primary"
                                onClick={handleSubmit(onSubmit)}
                            >
                                {"Submit"}
                            </DialogButtonPrimary>
                            {"    |    "}
                            <CustomButton
                                variant="contained"
                                color="primary"
                                onClick={logout}
                            >
                                Cancel
                            </CustomButton>
                        </FlexGridItem>
                    </Grid>
                </form >
            </FormProvider>
        }
    </>
}

